import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maringTop: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  }
});

const Filter = ({ classes, children }) =>
  <div className={classes.root}>
    {children}
  </div>

export default withStyles(styles)(Filter);



// WEBPACK FOOTER //
// ./src/components/core/Filter/Filter.jsx